import type { EsProductFragment } from '#graphql-operations'

export function useOfferFormDialog() {
  const { dialog, open, close: closeDialog } = useUiDialog('offer-form-dialog')
  const product = useState('offerFormDialogProduct', () => null as null | EsProductFragment)

  const openFor = (productData: EsProductFragment) => {
    product.value = productData
    open()
  }

  const close = () => {
    closeDialog()
    product.value = null
  }

  return {
    ...dialog,
    product,
    openFor,
    close,
  }
}
